import {NG_EVENT_PLUGINS} from '@taiga-ui/event-plugins';
import {TuiRoot} from '@taiga-ui/core';
import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, NgModule, provideExperimentalZonelessChangeDetection} from '@angular/core';
import moment from 'moment';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {
  NbAlertModule,
  NbButtonModule,
  NbCardModule,
  NbDatepickerModule,
  NbInputModule,
  NbLayoutModule,
  NbThemeModule
} from '@nebular/theme';
import {NbEvaIconsModule} from '@nebular/eva-icons';
import {CommonModule, registerLocaleData} from '@angular/common';
import {SharedModule} from 'compob2b-libs';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {environment} from '../environments/environment';
import {NbAuthModule} from '@nebular/auth';
import {AuthModule} from 'compob2b-auth';
import {ReactiveFormsModule} from '@angular/forms';
import {CabinetModule} from './cabinet/cabinet.module';
import {NgxSpinnerModule} from 'ngx-spinner';
import {AdminSignInComponent} from './sign-in/admin-sign-in.component';
import ru from '@angular/common/locales/ru';
import en from '@angular/common/locales/ru';
import {TUI_LANGUAGE} from '@taiga-ui/i18n';
import {of} from 'rxjs/internal/observable/of';
import {CalendarModule, DateAdapter, MOMENT} from 'angular-calendar';
import {SchedulerModule} from 'angular-calendar-scheduler';
import {adapterFactory} from 'angular-calendar/date-adapters/date-fns';
import {LoadingBarHttpClientModule} from '@ngx-loading-bar/http-client';
import {LoadingBarRouterModule} from '@ngx-loading-bar/router';
import {LOADING_BAR_CONFIG, LoadingBarModule} from '@ngx-loading-bar/core';
import {VersionReadyDialogComponent} from './admin-shared/version-ready-dialog/version-ready-dialog.component';
import {ServiceWorkerModule} from '@angular/service-worker';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {GANTT_GLOBAL_CONFIG, NgxGanttModule} from "@worktile/gantt";

registerLocaleData(ru);
registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent,
    AdminSignInComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    NbThemeModule.forRoot({name: 'default'}),
    NbEvaIconsModule,
    CommonModule,
    CabinetModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    TuiRoot,
    NbLayoutModule,
    AuthModule.forRoot(environment),
    NbAlertModule,
    NbInputModule,
    NbCardModule,
    NbButtonModule,
    SharedModule.forRoot(environment),
    NbAuthModule.forRoot({}),
    ReactiveFormsModule,
    NgxSpinnerModule,
    LoadingBarHttpClientModule,
    LoadingBarRouterModule,
    LoadingBarModule,
    NbDatepickerModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    SchedulerModule.forRoot({locale: 'en', headerDateFormat: 'daysRange'}),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production && environment.serviceWorkers,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    NgxGanttModule,
    VersionReadyDialogComponent
  ],
  providers: [
    {provide: LOADING_BAR_CONFIG, useValue: {latencyThreshold: 200}},
    {provide: LOCALE_ID, useValue: environment.locale},
    {provide: TUI_LANGUAGE, useValue: of(environment.tuiLanguage)},
    {provide: MOMENT, useValue: moment},
    provideExperimentalZonelessChangeDetection(),
    NG_EVENT_PLUGINS,
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: GANTT_GLOBAL_CONFIG,
      useValue: {
        locale: 'ru-ru',
        dateFormat: {
          timeZone: 'Europe/Moscow',
          weekStartsOn: 1
        }
      }
    },
    //provideZoneChangeDetection({ eventCoalescing: true })
  ]
})
export class AppModule {
}
